document.addEventListener('DOMContentLoaded', function() {
  var applyForm = document.getElementById('applyForm');

  if (applyForm) { // Check if the element exists
    applyForm.addEventListener('submit', function(e) {
      e.preventDefault(); // Prevent default form submission

      var formData = new FormData(this);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', ajax_object.ajax_url, true); // Use the localized variable
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 400) {
          var response = JSON.parse(xhr.responseText);

          if (response.success) {
            applyForm.reset(); // Reset form
            document.getElementById('confirmationMessage').textContent = response.data; // Show success message
            document.getElementById('confirmationMessage').style.display = 'block'; // Show message
          } else {
            document.getElementById('confirmationMessage').textContent = response.data; // Show error message
            document.getElementById('confirmationMessage').style.display = 'block'; // Show message
          }
        } else {
          document.getElementById('confirmationMessage').textContent = 'An error occurred. Please try again.'; // Show error message
          document.getElementById('confirmationMessage').style.display = 'block'; // Show message
        }
      };

      xhr.onerror = function() {
        document.getElementById('confirmationMessage').textContent = 'An error occurred. Please try again.'; // Show error message
        document.getElementById('confirmationMessage').style.display = 'block'; // Show message
      };

      xhr.send(formData);
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/autoload/_apply-email-handler.js